import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { User } from '../../../../../../types';
import WelcomeFields from './../welcome-fields';
import PopulateWelcomeTemplate from './../populate-welcome-template';
import { WelcomeTemplateFormValues } from '../welcome-templates-form-page';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface StepWelcomeTemplateSubjectProps {
  control: Control<WelcomeTemplateFormValues>;
  errors: FieldErrors<WelcomeTemplateFormValues>;
  watch: UseFormWatch<WelcomeTemplateFormValues>;
  user: User | undefined;
  setValue: UseFormSetValue<WelcomeTemplateFormValues>;
  getValues: UseFormGetValues<WelcomeTemplateFormValues>;
  disabled?: boolean;
}

export default function StepWelcomeTemplateSubject({
  control,
  errors,
  user,
  watch,
  setValue,
  getValues,
  disabled,
}: StepWelcomeTemplateSubjectProps) {
  const templateSubject = watch('templateSubject') || '';

  return (
    <Stack
      sx={{
        viewTransitionName: 'steps',
      }}
      gap={2}
      width={'100%'}
    >
      <Typography sx={{ mb: 1 }}>
        Please provide the email subject for your welcome template.
      </Typography>
      <Stack alignItems="flex-start">
        <Stack flexDirection="column" sx={{ width: '100%' }}>
          <Stack mt={-1}>
            <WelcomeFields
              setValue={setValue}
              getValues={getValues}
              disabled={disabled}
            />
          </Stack>
          <Stack gap={1} mt={2}>
            <Controller
              name="templateSubject"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Subject"
                  disabled={disabled}
                  autoComplete="off"
                  error={!!errors.templateSubject}
                  helperText={errors?.templateSubject?.message || ' '}
                  sx={{ minWidth: 400 }}
                  required
                />
              )}
            />
            <PopulateWelcomeTemplate
              user={user}
              template={templateSubject}
              plainText
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
